import { DocumentBlobBase } from "@bitory-gmbh/bsm";
import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
} from "@/shared/components/dialog/dialog-common";
import t from "@/lang/lang";
import { useDocumentBlobDeleteMutation } from "@/services/backend/filestorage/api/document-blob-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Button } from "@/shared/components/ui/button";

export function DocumentBlobDeleteDialog({
  base,
  disabled = false,
}: {
  base: DocumentBlobBase;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [del, { isLoading, error, isSuccess, reset }] =
    useDocumentBlobDeleteMutation();

  const doDelete = () => {
    if (isLoading) return;

    del(base);
  };

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
    }
  }, [isSuccess, reset]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive" disabled={disabled}>
          <Trash2 className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <CommonDialogHeader
          title={t("Datei löschen")}
          description={t("Datei wird unwiderruflich gelöscht.")}
        />
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doDelete} />
      </DialogContent>
    </Dialog>
  );
}
